export const getTotalValue = (list, field) => {
  let total = 0;
  list.forEach((element) => {
    const value = parseFloat(element[field]) || 0;
    total += value;
  });
  return total.toFixed(2);
};

export const checkRequiredField = (value) => {
  return value ? null : 'Required';
};

export const validateCheckedQuantity = (quantity, availableStock) => {
  if (!quantity) {
    return 'Debe ingresar un valor entero en el campo Cantidad';
  }

  if (!Number.isInteger(quantity)) {
    return 'Verifique el valor ingresado, no puede ser número decimal';
  }

  if (quantity.toString().length > 10) {
    return 'La longitud del valor ingresado no puede ser mayor a 10 digitos';
  }

  const quantityMaxAllowed = parseInt(availableStock, 10);
  if (quantity === 0 || quantity > quantityMaxAllowed) {
    return `Verifique el valor ingresado, no puede ser 0 ni mayor a ${quantityMaxAllowed}`;
  }
  return false;
};

export const validatePartPrice = (element) => {
  if (Number(element.price) < 0) {
    return 'Verifique el valor ingresado, no puede ser menor que cero';
  }
  return false;
};
